import { Box, Stack, TextField, Typography } from "@mui/material";
import type { FidelizacionConfig, FidelizacionLote } from "../fidelizacion-campana.interface";

export type ValoresEnvioHsm = { nombreHsm: string };

type Props = {
  config?: FidelizacionConfig;
  lote: FidelizacionLote | null;
  valores: ValoresEnvioHsm;
};

///* Datos con los que SocialHub hará el envío. El número de envío (AppId) y la
///* plantilla HSM se configuran en el ambiente (un solo valor cada uno), por eso
///* aquí solo se muestran, no se editan.
export const ConfiguracionEnvioHsm = ({ config, lote, valores }: Props) => {
  const appId = config?.app_id ?? "";
  const contactables = lote?.contactables ?? 0;
  const plantilla = valores.nombreHsm || config?.nombre_hsm || "";

  return (
    <Box>
      <Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems={{ md: "flex-start" }}>
        <TextField
          label="Número de envío"
          size="small"
          value={appId || "—"}
          fullWidth
          InputProps={{ readOnly: true }}
          helperText="Informativo · definido en SocialHub"
          sx={{ minWidth: 200 }}
        />

        <TextField
          label="Plantilla HSM"
          size="small"
          value={plantilla || "—"}
          fullWidth
          InputProps={{ readOnly: true }}
          helperText="Informativo · definida en SocialHub"
          sx={{ minWidth: 240 }}
        />
      </Stack>

      <Typography variant="caption" color="text.secondary" component="p" sx={{ mt: 1.5 }}>
        Destino: <strong>{contactables}</strong> contactos contactables · campaña{" "}
        {config?.campana_prefijo ?? "FIDELIZACION"}_L{lote?.id ?? "?"}
        {!plantilla.trim() && " · configura la plantilla HSM para habilitar el envío"}
      </Typography>
    </Box>
  );
};